import React from 'react'
import { Routes, Route } from 'react-router-dom'

import DefaultLayout from './templates/DefaultLayout'
import HomeLayout from './templates/HomeLayout'
import ErrorLayout from './templates/ErrorLayout'

import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

import Home from './pages/Home'
import GiftObject from './pages/GiftObject'
import Shops from './pages/Shops'
import RecoveryWorkshop from './pages/RecoveryWorkshop'
import ArtCraft from './pages/ArtCraft'
import Benefit from './pages/Benefit'
import Diy from './pages/Diy'
import {
	APP_BASE_URL,
	GIFT_OBJECT_URL,
	SHOP_URL,
	RECOVERY_WORKSHOP_URL,
	DIY_URL,
	BENEFIT_URL,
	ART_CRAFT_URL,
	DIARY_URL,
	HISTORY_URL,
	REFERENCE_TEAM_URL,
	EMPLOYMENT_SUPPORT_URL,
	PROJECTS_URL,
	PROJECT_URL,
	CONTACT_URL,
	ACTIVITY_REPORT_URL,
	RECRUITMENT_URL,
	BECOME_VOLUNTEER_URL,
	PARTNER_URL,
} from '../constants'

import '@fontsource/museomoderno'
import '@fontsource/montserrat'

import ActivityReport from './pages/ActivityReport'
import Diary from './pages/Diary'
import History from './pages/History'
import ReferenceTeam from './pages/ReferenceTeam'
import EmploymentSupport from './pages/EmploymentSupport'
import Projects from './pages/Projects'
import Project from './pages/Project'
import Contact from './pages/Contact'
import Recruitment from './pages/Recruitment'
import BecomeVolunteer from './pages/BecomeVolunteer'
import Partner from './pages/Partner'

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			refetchOnmount: false,
			refetchOnReconnect: false,
			retry: false,
			staleTime: 5 * 60 * 1000,
		},
	},
})

const App = () => {
	return (
		<QueryClientProvider client={queryClient}>
			<Routes>
				<Route path={APP_BASE_URL}>
					<Route element={<HomeLayout />}>
						<Route index element={<Home />} />
					</Route>
					<Route element={<DefaultLayout />}>
						<Route path={DIARY_URL} element={<Diary />} />
						<Route path={`${DIARY_URL}/:pageNumber`} element={<Diary />} />
						<Route path={HISTORY_URL} element={<History />} />
						<Route path={REFERENCE_TEAM_URL} element={<ReferenceTeam />} />
						<Route path={EMPLOYMENT_SUPPORT_URL} element={<EmploymentSupport />} />
						<Route path={PROJECTS_URL} element={<Projects />} />
						<Route path={`${PROJECTS_URL}/:pageNumber`} element={<Projects />} />
						<Route path={PROJECT_URL} element={<Project />} />
						<Route path={GIFT_OBJECT_URL} element={<GiftObject />} />
						<Route path={SHOP_URL} element={<Shops />} />
						<Route path={RECOVERY_WORKSHOP_URL} element={<RecoveryWorkshop />} />
						<Route path={ART_CRAFT_URL} element={<ArtCraft />} />
						<Route path={BENEFIT_URL} element={<Benefit />} />
						<Route path={DIY_URL} element={<Diy />} />
						<Route path={CONTACT_URL} element={<Contact />} />
						<Route path={`${CONTACT_URL}/:object`} element={<Contact />} />
						<Route path={ACTIVITY_REPORT_URL} element={<ActivityReport />} />
						<Route path={RECRUITMENT_URL} element={<Recruitment />} />
						<Route path={BECOME_VOLUNTEER_URL} element={<BecomeVolunteer />} />
						<Route path={PARTNER_URL} element={<Partner />} />
					</Route>
					<Route element={<ErrorLayout />}></Route>
				</Route>
			</Routes>
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	)
}

export default App
